package one.healthium.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class DailyTasksQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectTasksByDate(date: String, mapper: (
    id: String,
    date: String,
    name: String,
    type: String,
    color: Long,
    payload: String?,
    completionCount: Long,
  ) -> T): Query<T> = SelectTasksByDateQuery(date) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!
    )
  }

  public fun selectTasksByDate(date: String): Query<DailyTaskEntity> = selectTasksByDate(date, ::DailyTaskEntity)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertTask(dailyTaskEntity: DailyTaskEntity): Long {
    val result = driver.execute(-437_060_148, """INSERT OR REPLACE INTO dailyTaskEntity (id, date, name, type, color, payload, completionCount) VALUES (?, ?, ?, ?, ?, ?, ?)""", 7) {
          var parameterIndex = 0
          bindString(parameterIndex++, dailyTaskEntity.id)
          bindString(parameterIndex++, dailyTaskEntity.date)
          bindString(parameterIndex++, dailyTaskEntity.name)
          bindString(parameterIndex++, dailyTaskEntity.type)
          bindLong(parameterIndex++, dailyTaskEntity.color)
          bindString(parameterIndex++, dailyTaskEntity.payload)
          bindLong(parameterIndex++, dailyTaskEntity.completionCount)
        }.await()
    notifyQueries(-437_060_148) { emit ->
      emit("dailyTaskEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun incementTaskCompletionCount(id: String): Long {
    val result = driver.execute(655_030_203, """
        |UPDATE dailyTaskEntity SET completionCount = completionCount + 1
        |WHERE id = ?
        """.trimMargin(), 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(655_030_203) { emit ->
      emit("dailyTaskEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun clearAllCompletionCounts(): Long {
    val result = driver.execute(1_221_005_794, """UPDATE dailyTaskEntity SET completionCount = 0""", 0).await()
    notifyQueries(1_221_005_794) { emit ->
      emit("dailyTaskEntity")
    }
    return result
  }

  private inner class SelectTasksByDateQuery<out T : Any>(
    public val date: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("dailyTaskEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("dailyTaskEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(994_095_497, """
    |SELECT dailyTaskEntity.id, dailyTaskEntity.date, dailyTaskEntity.name, dailyTaskEntity.type, dailyTaskEntity.color, dailyTaskEntity.payload, dailyTaskEntity.completionCount FROM dailyTaskEntity
    |WHERE date = ?
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, date)
    }

    override fun toString(): String = "DailyTasks.sq:selectTasksByDate"
  }
}
